// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const articuno: PokeData = {
  "id": 144,
  "name": "articuno",
  "height": 17,
  "weight": 554,
  "base_experience": 261,
  "types": [
    PokeType.ICE,
    PokeType.FLYING
  ],
  "api_moves": [
    "gust",
    "leer",
    "mist",
    "ice-beam",
    "blizzard",
    "peck",
    "agility",
    "haze",
    "reflect",
    "sky-attack",
    "mind-reader",
    "powder-snow",
    "mirror-coat",
    "ancient-power",
    "hail",
    "sheer-cold",
    "roost",
    "tailwind",
    "ice-shard",
    "hurricane",
    "freeze-dry",
    "snowscape"
  ],
  "moves": [
    "gust",
    "leer",
    "blizzard",
    "peck",
    "reflect",
    "sky-attack",
    "ancient-power",
    "sheer-cold",
    "roost",
    "tailwind",
    "ice-shard",
    "hurricane",
    "chatter"
  ],
  "evolution_chain": {
    "id": 73,
    "item": null,
    "species": [
      {
        "name": "articuno",
        "order": 176,
        "types": [
          PokeType.ICE,
          PokeType.FLYING
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      }
    ]
  },
  "stats": {
    "resistance": 144,
    "speed": 121,
    "ability_power": 135
  },
  "stat_changes": [],
  "catch_rate": 3,
  "is_legendary": true,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
